<template>
  <div>
    <p class="user-type-title mb-1">회원 유형을 선택해주세요</p>
    <div style="width: 100%; display:flex; justify-content: space-between;" class="mb-5">
      <v-btn
        :class="userData.userType === 'DOCTOR' ? 'user-type-btn btn-text-white' : 'user-type-btn' "
        :color="userData.userType === 'DOCTOR' ? 'primary' : 'mainColorLight'"
        x-large
        depressed
        @click="$emit('clickUserType', 'DOCTOR')"
      >
        의사
      </v-btn>
      <v-btn
        :class="userData.userType === 'PHARMACIST' ? 'user-type-btn btn-text-white' : 'user-type-btn' "
        :color="userData.userType === 'PHARMACIST' ? 'primary' : 'mainColorLight'"
        x-large
        depressed
        class='user-type-btn'
        @click="$emit('clickUserType', 'PHARMACIST')"
      >
        약사
      </v-btn>
    </div>
  </div>
</template>
<script>export default {
  props: {
    userData: {
      type: Object,
    },
  },
};
</script>
<style lang="scss">
  .user-type-title {
    font-size: 14px;
    font-weight: 900;
    padding: 0 5px 5px;
    color: $primary-text-color;
    margin-top: 130px;
  }
</style>
